import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "../../services/login.service";
import { ToastrService } from "ngx-toastr";
import { CommonService } from "../../services/common.service";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { environment } from "../../../environments/environment";
import { ChatService } from "../../services/chat.service";
import { ActivatedRoute } from "@angular/router";
declare const register: any;
declare const statusRegister: any;

@Component({
  selector: "app-new-login",
  templateUrl: "./new-login.component.html",
  styleUrls: ["./new-login.component.css"],
})
export class NewLoginComponent implements OnInit {
  DEFAULT_PWD = "ABC123";
  data: any = {};
  emailId: string = "";
  emailPattern: RegExp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
  loginForm: any = UntypedFormGroup;
  apires: any;
  submitted = false;
  fieldTextType: boolean | undefined;

  WebSocket_URL = environment.WebSocket_URL;
  OpenVidu_URL = environment.OpenVidu_URL;
  roleId: any = "";
  userData: any;
  isBool: boolean = false;
  aluminiLogin: boolean = false;
  isUrlBasedLogo: boolean = false;
  showAuthCode: boolean = false;
  
  constructor(
    private userService: LoginService,
    private chatService: ChatService,
    private route: Router,
    private toastr: ToastrService,
    private commonService: CommonService,
    private fb: UntypedFormBuilder,
    private activeRoute: ActivatedRoute,
  ) {
    let findUrl: any = location.href;
    if (
      findUrl == "https://bedevapplicant.samvaadpro.com/login" ||
      findUrl == "https://api.kemis.konza.go.ke/login"
    ) {
      this.isBool = true;
    } else if (
      findUrl == "https://oukalumnidev.samvaadpro.com/login" ||
      findUrl == "https://oukalumniqa.samvaadpro.com/login"
    ) {
      this.aluminiLogin = true;
    }
    localStorage.clear();

    this.checkUrlLogo(findUrl);
  }

  checkUrlLogo(url: string) {
    const urlObj = {
      dhanushFinance: "https://finance.dhanushinfotech.com/login",
      financeDemo: "https://financedemo.dhanushinfotech.com/login",
      nwhQa: "https://nwhfinanceqa.dhanushinfotech.com/login",
      nwhPreprod: "https://nwhfinancepreprod.dhanushinfotech.com/login",
      nwhProd: "https://finance.himscmchbhopal.com/login",
    };
    const { nwhQa, nwhPreprod, nwhProd, dhanushFinance, financeDemo } = urlObj;
    if (
      dhanushFinance === url ||
      financeDemo === url ||
      nwhQa === url ||
      nwhPreprod === url ||
      nwhProd === url
    ) {
      this.isUrlBasedLogo = true;
      localStorage.setItem("isUrlBasedLogo", "true");
    } else {
      this.isUrlBasedLogo = false;
      localStorage.setItem("isUrlBasedLogo", "false");
    }
  }

  ngOnInit(): void {
    const bo: any = document.body;
    bo.style = "";

    this.loginForm = this.fb.group({
      userName: ["", Validators.required],
      password: ["", Validators.required],
      login_autogen_code: [null],
    });
    
    setTimeout(() => this.companyDetails(), 10);
    this.signFromHIMS();
  }

  get f() {
    return this.loginForm.controls;
  }

  signFromHIMS() {
    this.activeRoute.queryParams.subscribe((params) => {
      if (Object.keys(params).length) {
        const data = params["Finance"];
        this.loginHIMS(data);
      }
    });
  }

  loginHIMS(data: any) {
    this.commonService.activateSpinner();
    this.commonService
      .postCall(`Account/FinanceLogin`, { token: data })
      .subscribe((res: any) => {
        if (res.status) {
          const obj = JSON.parse(atob(res.data));
          this.loginForm.patchValue({
            userName: obj.username,
            password: obj.password,
          });
          this.registerUser();
        } else {
          this.toastr.warning(res.message);
        }
        this.commonService.deactivateSpinner();
      });
    this.commonService.deactivateSpinner();
  }

  async registerUser() {
    this.submitted = true;
    let user = this.loginForm.getRawValue();
    
    if (!user.userName.trim()) {
      document.getElementById("userName")?.focus();
      return;
    }

    if (!user.password.trim()) {
      document.getElementById("password")?.focus();
      return;
    }

    if (this.showAuthCode && !this.loginForm?.get("login_autogen_code").value) {
      this.toastr.warning("Enter Auth Code");
      return;
    }

    if (this.loginForm.invalid) {
      this.toastr.error("Please enter username or password");
      return;
    }

    const encryptedPassword = await this.commonService.encryptAesGcm(
      user.password.toString(),
      this.commonService.secretKey,
    );
    user.password = encryptedPassword;
    this.commonService.activateSpinner();
    
    this.userService.login(user).subscribe(
      async (succ: any) => {
        let userData: any = succ ?? {};
        
        if (userData.message === "Unique Code Sent To Your Email") {
          this.showAuthCode = true;
          this.toastr.success(userData.message);
          this.commonService.deactivateSpinner();
          return;
        }
        
        this.userData = userData;
        this.commonService.deactivateSpinner();

        // ✅ CHECK FOR EXISTING LOGIN FIRST - BEFORE ANY DATA STORAGE
        if (userData.is_tokenexist) {
          if (
            window.confirm(
              "Already you have logged in. Are you sure you want to logout and login again?",
            )
          ) {
            // User clicked OK - proceed with existing login flow
            let payload = {
              UserID: userData.USERID,
              AccessToken: userData.token,
              tnt_code: userData.TENANTCODE,
            };
            
            this.commonService
              .postCall("Account/SetToken", payload)
              .subscribe((res: any) => {
                // Now store data and proceed
                this.storeUserData(userData);
                this.handlePostLoginActions(userData);
              });
          } else {
            // ❌ User clicked CANCEL - redirect to login without storing anything
            this.commonService.deactivateSpinner();
            this.route.navigate(["/login"]);
            return;
          }
        } else {
          // ✅ No existing login - store data and proceed normally
          this.storeUserData(userData);
          this.handlePostLoginActions(userData);
        }
      },
      (err) => {
        let e = err.error;
        this.commonService.deactivateSpinner();
        this.toastr.error(e?.message || "Please try again later");
      },
    );
  }

  // ✅ NEW METHOD: Store all user data
  private storeUserData(userData: any) {
    this.userData = userData;

    localStorage.setItem(
      "MoodleUserName",
      userData?.moodle_adminloginusername,
    );

    // Decrypt role ID
    const decryptedValue: any = this.commonService.decryptAesGcm(
      userData.ROLEID,
      this.commonService.secretKey,
    );
    this.roleId = decryptedValue;

    // Store Moodle token
    if (this.roleId == "1") {
      localStorage.setItem("MoodleTkn", userData?.moodle_adminlogintoken);
    } else {
      localStorage.setItem("MoodleTkn", userData.moodle_token);
    }

    this.commonService.userId = userData.USERID;
    
    // Session storage
    sessionStorage.setItem("UserId", userData.USERID);
    sessionStorage.setItem("Username", userData.FIRSTNAME);
    sessionStorage.setItem("TenantCode", userData.TENANTCODE);
    sessionStorage.setItem("RoleId", userData.ROLEID);
    sessionStorage.setItem("refreshedRole", userData.ROLEID);
    sessionStorage.setItem("internshipUrl", userData.internship_url);
    sessionStorage.setItem("tnt_parent_code", userData.tnt_parent_code);
    sessionStorage.setItem("dashboard_path", userData.dashboard_angularpath);
    sessionStorage.USERNAME = userData.USERNAME;
    sessionStorage.FullName =
      `${userData.FIRSTNAME} ${userData.LASTNAME}`.toUpperCase();
    sessionStorage.profileImage = (userData.USERIMAGE || "data:,").replace(
      "data:,",
      "https://i.pinimg.com/736x/89/90/48/899048ab0cc455154006fdb9676964b3.jpg",
    );
    sessionStorage.userData = JSON.stringify(userData);
    sessionStorage.tntName = userData.tnt_name;

    // Local storage
    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("RoleName", userData.ROLE_NAME);
    localStorage.setItem("tkn", userData?.token);
    localStorage.setItem("accsTkn", userData.is_tokenexist);
    localStorage.setItem("IsKuccsps", userData.is_kuccps);
    localStorage.setItem("IsFirstLogin", userData.is_applfirstlogin);
    localStorage.setItem("tnt_logo", userData.tnt_logo);
    localStorage.setItem("MoodleUserId", userData.moodle_userid);
    localStorage.setItem("countyId", userData.county_id);
    localStorage.setItem("subCountyId", userData.subcounty_id);
    localStorage.setItem("instituteTyp", userData.institute_type);
    localStorage.setItem("schoolLevelID", userData.schoollevel);
    localStorage.setItem("region_id", userData.region_id);
    localStorage.setItem("UserId", userData.USERID);
    localStorage.setItem("Username", userData.FIRSTNAME);
    localStorage.setItem("TenantCode", userData.TENANTCODE);
    localStorage.setItem("RoleId", userData.ROLEID);
    localStorage.setItem("courseId", userData.CourseId);
    localStorage.setItem("countryID", userData?.country_id);
    localStorage.setItem("Proctoring", userData.allow_proctoring);
    localStorage.setItem("RoleName", userData.ROLE_NAME);
    localStorage.setItem("CourseId", userData.CourseId);
    localStorage.setItem("UserBaseSidebarMenu", userData.is_userbasisubmit);
    localStorage.setItem("isStudent", userData.is_student);
    localStorage.setItem("SchoolId", userData.category_id);
    localStorage.setItem("DepartmentId", userData.department_id);
    localStorage.setItem("TYPE", userData.type);
    localStorage.setItem("IsApplicant", userData.is_applicant);
    localStorage.setItem("ApplicantRoleId", userData.enrcryptedapplicantrole);
    localStorage.setItem("HimsUrl", userData.hims_url);
    localStorage.setItem("SMHRUrl", userData.smhr_url);
    localStorage.setItem("departmentId", userData.department_id);
    localStorage.setItem("mobileno", userData.mobileno);

    // Set username display
    const title = this.roleId == 3 ? "" : "Prof. ";
    let usrNme: string =
      title + `${userData.FIRSTNAME} ${userData.LASTNAME}`.toUpperCase();
    usrNme = usrNme.length > 25 ? usrNme.substring(0, 23) + ".." : usrNme;
    sessionStorage.usrNme = usrNme;
    sessionStorage.isLogIn = true;
    
    if (document.getElementById("user")) {
      (<HTMLInputElement>document.getElementById("user")).value = usrNme;
    }
  }

  // ✅ NEW METHOD: Handle all post-login actions
  private handlePostLoginActions(userData: any) {
    const { TenantCode = 0, UserId = 0, Username = "" } = sessionStorage;

    // Load courses for teachers
    if (+this.roleId == 2) {
      this.commonService
        .postCall("Courses/LoadCoursesByTrainer", {
          USER_ID: UserId,
          TNT_CODE: TenantCode,
        })
        .subscribe((rep) => {
          if (rep) {
            let courseList: Array<any> = rep.map((e: any) => ({
              courseId: e.COURSE_ID,
              courseName: e.COURSE_NAME,
              teacherId: UserId,
            }));
            const uniqueIds: any = [];
            courseList = courseList.filter((e: any) => {
              const isNotExist: boolean = !uniqueIds.includes(e.courseId);
              if (isNotExist) uniqueIds.push(e.courseId);
              return isNotExist;
            });
            (<any>window).courseInfo = courseList;
            (<any>window).is_login = true;
            sessionStorage.courseList = JSON.stringify(courseList);
            setTimeout(() => {
              // this.openVeduURLs();
              // this.webRTC_method(true, userData);
            }, 100);
          }
        });
    }

    // Connect chat for teachers and students
    if ([2, 3].includes(+this.roleId)) {
      const userType: string = this.roleId == 2 ? "Teacher" : "Student";
      const chatobject = { TenantCode, UserId, userType, Username };
      sessionStorage.ChatUser = JSON.stringify(chatobject);
      this.chatService.connectSocket(
        chatobject.TenantCode,
        chatobject.UserId,
        chatobject.userType,
        chatobject.Username,
      );
    }

    // Navigate based on role and first login status
    if (this.roleId == 3) {
      if (userData.is_firstlogin) {
        this.route.navigate(["/HOME/studentDashboard"]);
      } else {
        this.route.navigate(["/changePassword"]);
      }
    } else {
      this.route.navigate(
        userData.is_firstlogin
          ? [userData.dashboard_angularpath]
          : ["/changePassword"],
      );
    }
  }

  accessToken() {
    if (
      window.confirm(
        "Already you have logged in. Are you sure you want to logout and login again?",
      )
    ) {
      let payload = {
        UserID: this.userData.USERID,
        AccessToken: this.userData.token,
        tnt_code: this.userData.TENANTCODE,
      };
      this.commonService
        .postCall("Account/SetToken", payload)
        .subscribe((res: any) => {});
    } else {
      this.route.navigate(["/login"]);
    }
  }

  roleChange(rId: any, tntCode: any) {
    if (rId != "" && rId != undefined) {
      this.commonService.activateSpinner();
      this.commonService
        .getCall(`PermissionRole/GetListById/${tntCode}/${rId}`)
        .subscribe(
          (res: any) => {
            localStorage.setItem("isApprove", btoa(JSON.stringify(res.data)));
            this.commonService.deactivateSpinner();
          },
          (e) => {
            this.commonService.deactivateSpinner();
          },
        );
    }
  }

  getChartOfAccountInfo(tntCode: any): void {
    this.activeSpinner();
    this.commonService
      .getCall(`ChartOfAccount/GetList/${tntCode}/-1`)
      .subscribe(
        (res: any) => {
          this.deactiveSpinner();
          if (res.status == true && res.data.length > 0) {
            sessionStorage.chartOfAccountId = res.data[0].cha_chartofaccount_id;
            return +sessionStorage.chartOfAccountId;
          }
        },
        (e) => {
          this.deactiveSpinner();
        },
      );
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  navigateToOuk() {
    window.open("https://ouk.ac.ke/");
  }

  validateEmail(event: any) {
    let val = event.target.value.trim();
    let exp = this.emailPattern;

    if (!new RegExp(exp).test(val)) {
      this.toastr.warning(
        "Invalid email credentials, please enter a valid email",
      );
      return;
    }
    this.emailId = val;
  }

  close() {
    this.emailId = "";
  }

  activeSpinner() {
    this.commonService.activateSpinner();
  }

  deactiveSpinner() {
    this.commonService.deactivateSpinner();
  }

  onForgotPasswordClick() {
    this.activeSpinner();
    if (!this.emailId || !this.emailPattern.test(this.emailId)) {
      this.toastr.warning("Please enter a valid email id");
      this.emailId = "";
      this.deactiveSpinner();
      return;
    }
    let originUrl = new URL(window.location.href);
    let payload = {
      UserName: this.emailId,
      Url: originUrl.origin,
    };
    const API = this.isBool
      ? "Account/InitialApplicantForgotPassword"
      : "Account/ForgotPassword";
    this.commonService.postCall(API, payload).subscribe(
      (res: any) => {
        this.apires = res;
        this.toastr.success(this.apires?.message);
        document.getElementById("md_close")?.click();
        this.emailId = "";
        this.deactiveSpinner();
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error?.message : err.error?.message);
        this.deactiveSpinner();
      },
    );
  }

  companyDetails() {
    const { fileUrl } = environment;
    if (sessionStorage.homepageimage_path) {
      document
        .getElementById("homepageimage_path")
        ?.setAttribute(
          "src",
          `${fileUrl}${sessionStorage.homepageimage_path} `,
        );
    }
  }

  gotoSignUp() {
    this.route.navigate(["student-signup"]);
  }

  openVeduURLs() {
    (<HTMLInputElement>document.getElementById("ovUrl")).value =
      this.OpenVidu_URL;
    (<HTMLInputElement>document.getElementById("ovKey")).value = "dipl123";
    (<HTMLInputElement>document.getElementById("apUrl")).value =
      this.WebSocket_URL;

    (<any>window).OPENVIDU_SERVER_URL = this.OpenVidu_URL;
    (<any>window).OPENVIDU_SERVER_SECRET = "dipl123";
    (<any>window).vidmed_url = `${this.WebSocket_URL}telecon/`;

    sessionStorage.OpenVidu_URL = this.OpenVidu_URL;
    sessionStorage.WebSocket_URL = this.WebSocket_URL;
  }

  webRTC_method(isTeacher: boolean = true, userData: any) {
    if (!userData) return;
    const userInfo = {
      toId: "",
      fromId: `tea_${userData.USERID}`,
      name: userData.FIRSTNAME,
      userType: 1,
      complaints: "",
      myId: userData.USERID,
      usrTkn: "",
    };

    userInfo.usrTkn = `org_${userData.TENANTCODE}_${userData.TNT_NAME}_${
      userInfo.fromId
    }_${userData.FIRSTNAME}_${new Date().getTime()}`.replace(/ /g, "_");
    (<HTMLInputElement>document.getElementById("sessionName")).value =
      userInfo.fromId;
    (<HTMLInputElement>document.getElementById("fromId")).value =
      userInfo.fromId;
    (<HTMLInputElement>document.getElementById("toId")).value = userInfo.toId;

    (<HTMLInputElement>document.getElementById("newUserId")).value =
      userInfo.usrTkn;

    if (+userInfo.userType === 1) {
      register(
        userInfo.toId,
        userInfo.fromId,
        userInfo.name,
        userInfo.userType,
      );
      statusRegister();
      sessionStorage.userInfo = JSON.stringify(userInfo);
    }
  }
  
  gotoSchoolRegister() {
    this.route.navigate(["/institution-reg"]);
  }

  goBack() {
    this.route.navigate(["/landingPage"]);
  }
}